<template>
  <div
    class="relative"
    :class="{ 'kavili-content-above': !isWelcomeRoute }"
  >
    <!-- <div
      style="z-index:10"
      class="snow-animation"
    >
      <Snow />
    </div> -->
    <!-- <div>
      <KaviliRain
        :z-index="kaviliZIndex"
        class="kavili-rain"
      />
    </div> -->
    <layout-vertical>
      <div>
        <MsgBanner class="top-banner" />
        <router-view />
      </div>

      <template #navbar="{ toggleVerticalMenuActive }">
        <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
    </layout-vertical>
  </div>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
// import Snow from '@/components/Snow/Snow.vue'
// import KaviliRain from '@/components/Awrudu/KaviliRain.vue'
import Navbar from '../components/Navbar.vue'
import MsgBanner from '../../components/Notification/msg_banner.vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
    // Snow,
    // KaviliRain,
    MsgBanner,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
  computed: {
    isWelcomeRoute() {
      return this.$route?.name === 'welcome'
    },
    kaviliZIndex() {
      // welcome: rain overlays everything
      // other routes: rain overlays navbars, but content overlays rain
      return this.isWelcomeRoute ? 2000 : 8
    },
  },
}
</script>
<style>
@media print {
  /* Global Styles */

  /* Exclude snow animation from print */
  .snow-animation {
    display: none !important;
  }

   /* Exclude top banner from print */
   .top-banner {
    display: none !important;
  }

  /* Rest of your existing print styles */
  /* Exclude kavili animation from print */
  .kavili-rain {
    display: none !important;
  }
}

/* .kavili-content-above .main-menu {
  z-index: 5;
}

.kavili-content-above .app-content.content {
  z-index: auto;
}

.kavili-content-above .content-wrapper {
  position: relative;
  z-index: 10;
} */
</style>
